import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeagueService {

  rootUri = (environment.ktRootUri) ? environment.ktRootUri : "";

  constructor(private http: HttpClient) { }

  getLeagueList() {
    return this.http.get<League[]>(`${this.rootUri}/api/leagues/all`);
  }

  getLeagueDetails(leagueid: string) {
    return this.http.get<League>(`${this.rootUri}/api/leagues/fetch/${leagueid}`);
  }

  createNewLeague(league: NewLeague) {
    return this.http.post<League>(`${this.rootUri}/api/leagues/new`, league);
  }

  fetchGameTypes() {
    return this.http.get<GameTypeStub[]>(`${this.rootUri}/api/gametype/all`);
  }

  updateLeague(leagueid: string, league: NewLeague) {
    return this.http.post<League>(`${this.rootUri}/api/leagues/edit/${leagueid}`, league);
  }

  deleteLeague(leagueid: string) {
    return this.http.post<boolean>(`${this.rootUri}/api/leagues/delete/${leagueid}`, {});
  }

  getPlaceCoordinates(placeId: string) {
    return this.http.get<{lat: number, lng: number}>(`${this.rootUri}/api/typeahead/place-coordinates?place-id=${placeId}`);
  }
}
